import { createStore, applyMiddleware, compose } from "redux";
import { persistStore, persistReducer } from "redux-persist";
// localStorage instead of sessionStorage: sessionStorage is per-tab, so a
// new tab opened from the sidebar (or any tab that doesn't inherit the
// opener's storage) always started blank and showed the login screen even
// though the account was already logged in elsewhere on the same browser.
// localStorage is shared by every tab of the same origin, so a new tab
// picks up the existing login. The account-level "single active session"
// rule (loginMaster.AuthToken + heartbeat staleness, see AuthController.js)
// still governs whether the token is actually accepted server-side.
import storage from "redux-persist/lib/storage";
import thunk from "redux-thunk";
import rootReducer from "./rootReducer";

const persistConfig = {
  key: "root",
  storage,
};
const persistedReducer = persistReducer(persistConfig, rootReducer); //persist reducer combine both local and root reducer
export default () => {
  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  let store = createStore(persistedReducer, {}, composeEnhancers(applyMiddleware(thunk))); //apply middleware to run rootreducer
  let persistor = persistStore(store);
  return { store, persistor };
};
